module.exports = __webpack_public_path__ + "media/images/devices/device-intro-143e6b396b893f9bec019345a3afc746.png";